import React, { useEffect, useRef, useState } from 'react'
import { Table } from './tables/Table';
import { TableSummary } from './tables/TableSummary';
// import "./../public/assets/css/modalEspecial.css"; // 👈 Importa estilos separados

// import "./../../public/assets/css/modalEspecial.css"


export const ModalSummary = ({ type, onClose, closeOnEscape = true, closeOnBackdrop = true }) => {

  // console.log(type);
  /**
   * ToDo:
   * - Falta la logica para buscar data en base de datos,
   * - Falta todo el backend
   * - agregar loading correspondiente
  */

  const [isVisible, setIsVisible] = useState(false);
  //  Comportamiento de clic fuera de modal se cierra
  const dialogRef = useRef(null);

  // Fade-in al montar
  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  // Cerrar con Escape si está permitido
  useEffect(() => {
    if (!closeOnEscape) return;

    const handleKeyDown = (e) => {
      if (e.key === "Escape") handleClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [closeOnEscape]);

  // Cerrar con clic fuera si está permitido
  const handleBackdropClick = (e) => {
    if (!closeOnBackdrop) return;
    if (dialogRef.current && !dialogRef.current.contains(e.target)) {
      handleClose();
    }
  };

  // Animación al cerrar
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(onClose, 250); // espera la animación
  };






  let title = "";
  switch (type) {
    case 1:
      title = "Detalle de Productos: Existencias optimas"
      break;
    case 2:
      title = "Detalle de Productos: Existencias bajas"
      break;
    case 3:
      title = "Detalle de Productos: Existencias minimas"
      break;
    case 4:
      title = "Detalle de Productos: Deben resurtirse"
      break;
    case 5:
      title = "Detalle de Productos: Deben resurtirse/ Agotados"
      break;
    case 6:
      title = "Detalle de Ordenes de compra: Pendiente"
      break;
    case 7:
      title = "Detalle de Ordenes de compra: Solicitadas"
      break;
    case 8:
      title = "Detalle de Ordenes de compara: En proceso"
      break;
    case 9:
      title = "Detalle de Ordenes de compra: Inversion realizada"
      break;
    case 10:
      title = "Detalles de Productos: Mas vendido(s)"
      break;
    case 11:
      title = "Detalles de Productos: Menos vendido(s)"
      break;
    case 12:
      title = "Detalles de Productos: Con Orden de compra"
      break;
    default:
      title = "No disponible"
      break;
  }


  const productos = [
    { id: 1, categoria: 'LAPTOP', nombre: 'Laptop Dell XPS', tipo: 'productosOptimos', stock: 50, costo: 1500, precio: 3000 },
    { id: 2, categoria: 'PERIFERICOS', nombre: 'Monitor 27" LG', tipo: 'productosOptimos', stock: 20, costo: 1500, precio: 3000 },
    { id: 3, categoria: 'PC', nombre: 'PC Gamer Ryzen', tipo: 'productosbajas', stock: 5, costo: 1500, precio: 3000 },
    { id: 4, categoria: 'PERIFERICOS', nombre: 'Teclado Mecánico', tipo: 'productosMinimos', stock: 2, costo: 1500, precio: 3000 },
    { id: 5, categoria: 'PERIFERICOS', nombre: 'Mouse Gamer', tipo: 'productosResurtir', stock: 1, costo: 1500, precio: 3000 },
    { id: 6, categoria: 'COMPONENTES', nombre: 'GPU RTX 4080', tipo: 'productosAgotados', stock: 0, costo: 1500, precio: 3000 },
  ];

  // Definicion de columnas para type del 1 al 5
  let columnsProducts = [
    {
      header: 'SKU',
      dataIndex: 'id',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'CATEGORIA',
      dataIndex: 'categoria',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'NOMBRE',
      dataIndex: 'nombre',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'EXISTENCIAS',
      dataIndex: 'stock',
      classHeader: 'text-center',
      classRow: 'text-center',
    },
    {
      header: 'COSTO',
      dataIndex: 'costo',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'PRECIO',
      dataIndex: 'precio',
      classHeader: 'text-end',
      classRow: 'text-end',
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
  ];


  const ordenesCompra = [
    {
      id: 1,
      proveedor: "Tech Supplies S.A.",
      fecha_solicitud: "2025-10-10",
      fecha_entrega: "2025-10-20",
      producto: "Laptop Dell XPS",
      categoria: "LAPTOP",
      cantidad: 10,
      costo_compra: 15000,
      estado: "Pendiente",
    },
    {
      id: 2,
      proveedor: "GamerWorld MX",
      fecha_solicitud: "2025-10-12",
      fecha_entrega: "2025-10-22",
      producto: "Monitor 27\" LG",
      categoria: "PERIFERICOS",
      cantidad: 5,
      costo_compra: 7500,
      estado: "Solicitada",
    },
    {
      id: 3,
      proveedor: "ComponentesPro",
      fecha_solicitud: "2025-10-11",
      fecha_entrega: "2025-10-25",
      producto: "GPU RTX 4080",
      categoria: "COMPONENTES",
      cantidad: 2,
      costo_compra: 50000,
      estado: "En proceso",
    },
    {
      id: 4,
      proveedor: "OfiTech",
      fecha_solicitud: "2025-10-09",
      fecha_entrega: "2025-10-19",
      producto: "Teclado Mecánico",
      categoria: "PERIFERICOS",
      cantidad: 20,
      costo_compra: 4000,
      estado: "Inversión realizada",
    },
  ];
  // Definicion de columnas para type 6 al 9
  let columnsOrdenes = [
    {
      header: 'FOLIO',
      dataIndex: 'id',
      classHeader: 'text-start',
      classRow: 'text-start',
    },
    {
      header: 'PROVEEDOR',
      dataIndex: 'proveedor',
      classHeader: 'text-start',
      classRow: 'text-start',
      isTotal: false, // 👈 sumará esta columna
      // renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'F. SOLICITADA',
      dataIndex: 'fecha_solicitud',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: false, // 👈 sumará esta columna
      // renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'CANTIDAD',
      dataIndex: 'cantidad',
      classHeader: 'text-center',
      classRow: 'text-center',
      isTotal: true, // 👈 sumará esta columna
      // renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },
    {
      header: 'COSTO',
      dataIndex: 'costo_compra',
      classHeader: 'text-end',
      classRow: 'text-end',
      isTotal: true, // 👈 sumará esta columna
      renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
    },

  ];

  const renderTable = () => {
    if (type >= 1 && type <= 5) return <Table columns={columnsProducts} data={productos} function_={[]} placeholderSearch="Buscar producto" showPagination={false} showControls={false} showTotals={false} />;
    if (type >= 10 && type <= 15) return <Table columns={columnsProducts} data={productos} function_={[]} placeholderSearch="Buscar producto" showPagination={false} showControls={false} showTotals={false} />;
    if (type >= 6 && type <= 10) return <TableSummary columns={columnsOrdenes} data={ordenesCompra} function_={[]} placeholderSearch="Buscar Orden de Servicio / Venta" showPagination={false} showControls={false} showTotals={true} countRow={false} showAverage={false} />;
    return <p>No hay tabla disponible para este tipo.</p>;
  };

  if (!type) return null;


  return (
    <div className={`modal d-block custom-backdrop ${isVisible ? "show" : ""}`} onClick={handleBackdropClick}>
      <div ref={dialogRef} className={`modal-dialog modal-lg custom-modal-animate ${isVisible ? "show" : ""}`}>
        <div className="modal-content" style={{ backgroundColor: "#ffffff" }}>
          <div className="modal-header">
            <h5 className="modal-title fw-bold">{title}</h5>
            <button type="button" className="btn-close" onClick={handleClose}></button>
          </div>
          <div className="modal-body">{renderTable()}</div>
          <div className="modal-footer">
            <button className="btn btn-outline-dark" onClick={handleClose}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


